import { statusToText } from './formatter'
import moment from 'moment-timezone'

export const checkStatus = (data, status) => {
  return status === statusToText(data)
}

export const checkConnected = (data, status) => {
  if (status === 'Terkoneksi') {
    return !!data.user
  } else if (status === 'Tidak Aktif') {
    const now = moment().tz('Asia/Jakarta')
    return moment(data.expiredAt).tz('Asia Jakarta').isBefore(now)
  } else {
    return !data.user
  }
}
